import React, { Component, useEffect, useRef, useState } from 'react'
import updateField from '../../actionCreators/updateField'
import updateSheet from '../../actionCreators/updateSheet'
import { connect } from 'react-redux'
import HeaderFormatOptions, { dateFormats } from './HeaderFormatOptions'
import { listenForOutsideClick } from './previewUtils'
import { SpreadsheetHeader, SpreadsheetType } from '../main/options/model/types'

interface IProps {
    update?: boolean
    updateCell: (cell: SpreadsheetHeader) => void
    updateField: any
    updateSheet: any
    onlyView?: boolean
    cell: SpreadsheetHeader
}

function HeaderFormat({ update, updateField, updateSheet, onlyView, cell, updateCell }: IProps): JSX.Element {
    const { alias, isDisabled, isKey, isNotNull, name, type, format = '' } = cell
    const [opened, setOpened] = useState<boolean>(false)
    const [listening, setListening] = useState<boolean>(false)
    const menuRef = useRef(null)

    useEffect(() => {
        listenForOutsideClick(listening, setListening, menuRef, setOpened)
    })

    const updateFormat = (type: SpreadsheetType, format: string) => {
        updateCell({
            ...cell,
            type,
            format
        })
    }

    const toggle = () => {
        setOpened(!opened)
    }

    const close = () => {
        setOpened(false)
    }

    const handleClickOutside = () => close()

    const text = (): string => {
        return type === 'string'
            ? 'Text'
            : type === 'number'
            ? `Number (ex: 99${format}00)`
            : type.startsWith('date')
            ? 'Date (' + dateFormats[format] + ')'
            : 'Text'
    }

    if (onlyView == true) {
        return (
            <th style={{ position: 'relative' }} onClick={toggle}>
                <span className="selected-type">{text()}</span>
            </th>
        )
    }

    return (
        <th ref={menuRef} style={{ position: 'relative' }} onClick={toggle}>
            <span className="selected-type">{text()}</span>
            <i className={`fa fa-caret-${opened ? 'up' : 'down'}`} aria-hidden="true" />
            {opened ? (
                <HeaderFormatOptions
                    update={update}
                    type={type}
                    format={format}
                    close={close}
                    onChange={updateFormat}
                />
            ) : null}
        </th>
    )
}

export default connect(null, {
    updateField,
    updateSheet
})(HeaderFormat)
